export default "__VITE_ASSET__1BjyT0YX__"